import { IIconProps } from './add';

export const IcoPlusWithCircle: React.FC<IIconProps> = ({ style, cy }) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    data-cycy={`IcoPlusWithCircle${cy}`}
  >
    <path
      d="M8.75 3.75H7.25V6.75H4.25V8.25H7.25V11.25H8.75V8.25H11.75V6.75H8.75V3.75ZM8 0C3.86 0 0.5 3.36 0.5 7.5C0.5 11.64 3.86 15 8 15C12.14 15 15.5 11.64 15.5 7.5C15.5 3.36 12.14 0 8 0ZM8 13.5C4.6925 13.5 2 10.8075 2 7.5C2 4.1925 4.6925 1.5 8 1.5C11.3075 1.5 14 4.1925 14 7.5C14 10.8075 11.3075 13.5 8 13.5Z"
      fill="currentColor"
    />
  </svg>
);
